import { AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TermsModel } from '../../../models-otc/terms-model';
import { CropsModel } from '../../../models-otc/crops-model';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OrdersModel } from '../../../models-otc/orders-model';
import { OrdersService } from '../../../services-otc/orders.service';
import { OrdersDto } from '../../../dto-otc/orders-dto';
import { CustomerService } from '../../../services-otc/customer.service';
import { CustomerModel } from '../../../models-otc/customer-model';
import { MetadataService } from '../../../services-otc/metadata.service';
import { AddNoteComponent } from '../../dialogs-otc/add-note/add-note.component';
import { RemoveNoteComponent } from '../../dialogs-otc/remove-note/remove-note.component';
import { EditNoteComponent } from '../../dialogs-otc/edit-note/edit-note.component';
import { AttachItemComponent } from '../../dialogs-otc/attach-item/attach-item.component';
import { RemoveAttachmentComponent } from '../../dialogs-otc/remove-attachment/remove-attachment.component';
import { EditAttachmentComponent } from '../../dialogs-otc/edit-attachment/edit-attachment.component';
import { HelperService } from '../../../../helper.service';
import { AddAltAddressComponent } from '../../dialogs-otc/add-alt-address/add-alt-address.component';
import { BehaviorSubject, ReplaySubject, Subject, catchError, of, takeUntil, throwError } from 'rxjs';
import { AddCoOpComponent } from '../../dialogs-otc/add-co-op/add-co-op.component';
import { AddressModel } from '../../../models-otc/address-model';
import dayjs from 'dayjs';
import { NotesModel } from '../../../models-otc/notes-model';
import { NotesService } from '../../../services-otc/notes.service';
import { MatTableDataSource } from '@angular/material/table';
import { ItemModel } from '../../../models-otc/item-model';
import { ClearItemsComponent } from '../../dialogs-otc/clear-items/clear-items.component';
import { AddItemComponent } from '../../dialogs-otc/add-item/add-item.component';
import { NavBarComponent } from '../../../../nav-bar/nav-bar.component';
import { CoOpMemberModel } from '../../../models-otc/co-op-member-model';
import { CoOpMemberService } from '../../../services-otc/co-op-member.service';
import { AttachmentsService } from '../../../services-otc/attachments.service';
import { AttachmentModel } from '../../../models-otc/attachment-model';
import { ItemService } from '../../../services-otc/item.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RemoveItemComponent } from '../../dialogs-otc/remove-item/remove-item.component';
import { DiscountModel } from '../../../models-otc/discount-model';
import { RemoveOrderComponent } from '../../dialogs-otc/remove-order/remove-order.component';
import { OrderTotalsModel } from 'src/app/order-to-cash/models-otc/order-totals-model';
import { OrderBackComponent } from '../../dialogs-otc/order-back/order-back.component';
import { SubmitToSapComponent } from '../../dialogs-otc/submit-to-sap/submit-to-sap.component';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ApproveOrderComponent } from "../../dialogs-otc/approve-order/approve-order.component";
import { RejectOrderComponent } from "../../dialogs-otc/reject-order/reject-order.component";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { HttpResponse } from '@angular/common/http';
import { CopyOrderComponent } from '../../dialogs-otc/copy-order/copy-order.component';
import { RecallConfirmationComponent } from '../../dialogs-otc/recall-confirmation/recall-confirmation.component';
import { PlantSelectionService } from 'src/app/order-to-cash/services-otc/plant-selection.service';
import { OrderSuffixModel } from 'src/app/order-to-cash/models-otc/order-suffix-model';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD.MM.YYYY"
  },
  display: {
    dateInput: "DD.MM.YYYY",
    monthYearLabel: "DD.MM.YYYY",
    dateA11yLabel: "DD.MM.YYYY",
    monthYearA11yLabel: "DD.MM.YYYY"
  }
};

@Component({
    selector: 'app-new-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: false
})
export class OrderComponent implements OnInit, OnDestroy , AfterContentInit{

  panelOpenState = false;
  isHistoryPanelOpen = false;

  /** control for the selected payer and sold-to */
  public payerCtrl: FormControl<CustomerModel> = new FormControl<CustomerModel>(null);
  public soldToCtrl: FormControl<CustomerModel> = new FormControl<CustomerModel>(null);
  public altAddressCtrl: FormControl<AddressModel> = new FormControl<AddressModel>(null);
  public memberNumberCtrl: FormControl<CoOpMemberModel> = new FormControl<CoOpMemberModel>(null);

  /** control for the MatSelect filter keyword */
  public payerFilterCtrl: FormControl<string> = new FormControl<string>('');
  public soldToFilterCtrl: FormControl<string> = new FormControl<string>('');
  public altAddressFilterCtrl: FormControl<string> = new FormControl<string>('');
  public memberNumberFilterCtrl: FormControl<string> = new FormControl<string>('');
  public cropFilterCtrl: FormControl<string> = new FormControl<string>('');

  /** list of payers and sold-to filtered by search keyword */
  public filteredPayers: ReplaySubject<CustomerModel[]> = new ReplaySubject<CustomerModel[]>(1);
  public filteredSoldTos: ReplaySubject<CustomerModel[]> = new ReplaySubject<CustomerModel[]>(1);
  public filteredAltAddresses: ReplaySubject<AddressModel[]> = new ReplaySubject<AddressModel[]>(1);
  public filteredMemberNumbers: ReplaySubject<CoOpMemberModel[]> = new ReplaySubject<CoOpMemberModel[]>(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onPayerDestroy = new Subject<void>();
  protected _onSoldToDestroy = new Subject<void>();
  protected _onAltAddressDestroy = new Subject<void>();
  protected _onMemberNumberDestroy = new Subject<void>();

  newOrderForm: FormGroup;

  availableTermList: TermsModel[];
  cropList: CropsModel[];
  orderSuffixListList: OrderSuffixModel[];
  selectedSuffix: OrderSuffixModel;
  filteredCropList: CropsModel[] = [];
  coOpMemberList: CoOpMemberModel[];
  customers: CustomerModel[] = [];
  items: ItemModel[] = [];
  discountValidationItems: DiscountModel[];
  notes: NotesModel[];
  attachments: AttachmentModel[];
  attachmentObj: AttachmentModel = <AttachmentModel>{};
  orderObj: OrdersModel = <OrdersModel>{};
  updatedOrderObj: OrdersModel = <OrdersModel>{};
  selectedTerm: TermsModel;
  isUpdating: boolean = true;
  selectedSoldToCustomer: CustomerModel;
  selectedPayerCustomer: CustomerModel;
  altAddress: AddressModel;
  orderTotals: OrderTotalsModel
  itemData: any;
  payerObj: CustomerModel;

  ordersDto: OrdersDto;

  selectedDeliveryAddressId: number;
  orderStatus: number;

  orderStatusTypeObj = {
    draftStatus: 1,
    submittedStatus: 2,
    pendingManagerApprovalStatus: 3,
    approvedStatus: 4,
    rejectedStatus: 5,
    clientApprovalStatus: 6,
    clienrRejectedStatus: 7,
    submittedToSapStatus: 8,
    sapSubmitFailed: 9,
    editSubmitedToSapStatus: 10,
    updatedSubmitedToSapStatus: 11,
    pendingTermManagerApprovalStatus: 12,
    recalledStatus: 13
  }

  orderCurrentStatus: number = 0;
  approveStatusId = 1;
  rejectStatusId = 2;
  selectedPaymentId: number;
  totalTons: number = 0;
  convertedTotalTons: string = '';
  netValueRunit: number = 0;
  totalExVat: number = 0;
  vatPercentage: number = 15;

  isCustomerSelected: boolean = false;
  isAltCustomerAddressChecked: boolean = false;
  isAltCustomerAddressSelected: boolean = false;
  hideSoldToAddress: boolean = false;
  isDirectPayerSelected: boolean = false;
  kBChecked: boolean = false;
  pFChecked: boolean = false;
  inDiscountLevel: boolean = false;
  isItemEditMode: boolean = false;
  // payerRestet: boolean = false;
  isEditOrderOptionsEnabled: boolean;
  isDraft: boolean = false;
  isPendingApproval: boolean = false;
  isRecallable: boolean = false;
  isRecallEnabled: boolean = false;
  isMobileNoticeVisible: boolean = false;
  isAddItemEnabled: boolean = false;
  submittedToSap: boolean = false;
  isOrderDateExpired: boolean = false;
  isPayerCoop: boolean = false;
  routingOrigins: string = null;
  isKb: boolean = false;
  isPf: boolean = false;
  isSuffixVisable: boolean = false;
  isPaymentDateVisable: boolean = false;
  isCustomerDeleted: boolean = false;
  isEditOrderEnabled: boolean = false;
  showNotice: boolean;
  showNoticeSplitterOne: boolean = false;
  showNoticeSplitterTwo: boolean = false;
  showDiscNotice: boolean;
  showTermsNotice: boolean = false;
  showOldDateNotice: boolean = false;
  isOutsideDiscountLev: boolean;
  isOrderToSapBtnDisabled: boolean = false;
  isCopyOrderEnabled: boolean = false;
  hideButtonOptions: boolean = true;

  isOwnTransport: any;
  resultTEST: any;

  protected readonly dayjs = dayjs;

  maxDate = '';
  minDate = new Date();
  minFixedPaymentDate: Date | null = null;

  dateStringFormatting = 'DD.MM.YYYY';
  dateStingFormattingSAP = 'DD.MM.YYYY';
  currentDate = dayjs();
  validToDate: string;
  orderDate: string;
  fixedPaymentDate: string;
  placeholder = '-';
  totalDiscount: string;
  discountExceeded: string;
  termsExceeded: string;
  salesPriceRequired: string = '-';
  saveDraftBtn: string = 'SAVE DRAFT';
  updateOrderBtn: string = 'UPDATE ORDER';
  submitToSapBtn: string = 'SUBMIT TO SAP';
  submitUpdatedBtn: string = 'SUBMIT UPDATE';
  saveUpdateBtn: string = '';
  submitBtn: string = '';
  approvalMessage: string = '';

  email: string = '';
  subject: string = '';

  approvalMessageSplit: string[] = [];

  displayedColumns: string[] = [
    'action',
    'plant',
    'material',
    'qty',
    'unitOfMeasure',
    'delDate',
    'ownTransport',
    'listPrice',
    'totalPrice',
    'specialDiscountPercentage',
    'tradeDiscountPercentage',
    'transportExpense',
    'handlingCharge',
    'netValueRUnit',
    'totalExclVat'
  ];

  dataSource = new MatTableDataSource<ItemModel>([]);

  constructor(
    public helper: HelperService,
    private ordersService: OrdersService,
    private customerService: CustomerService,
    private itemService: ItemService,
    private metadataService: MetadataService,
    private coOpMemberService: CoOpMemberService,
    private notesService: NotesService,
    private attachmentsService: AttachmentsService,

    private editAltAddressDialog: MatDialog,
    private addCoOpDialog: MatDialog,
    private submitToSapDialog: MatDialog,
    private orderBackDialog: MatDialog,
    private approveDialog: MatDialog,
    private rejectDialog: MatDialog,
    private clearItemsAlertDialog: MatDialog,
    private addItemDialog: MatDialog,
    private deleteItemDialog: MatDialog,
    private addNoteDialog: MatDialog,
    private deleteNoteDialog: MatDialog,
    private editNoteDialog: MatDialog,
    private addNewAttachmentDialog: MatDialog,
    private removeAttachmentAlertDialog: MatDialog,
    private replaceAttachmentDialog: MatDialog,
    private copyOrderComponentDialog: MatDialog,
    private recallDialog: MatDialog,

    private newOrderFb: FormBuilder,
    public nav: NavBarComponent,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectiondTerms: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    private plantSelectionService: PlantSelectionService

  ) {
    this.isAltCustomerAddressSelected = false;

    this.newOrderForm = this.newOrderFb.group({
      id: null,
      orderType: null,
      salesOrg: null,
      salesOffice: null,
      distributionChannel: null,
      division: null,
      orderDate: [null, Validators.required],
      currency: null,
      pricingDate: null,
      soldToId: [null, Validators.required],
      billToId: null,
      payerId: [null, Validators.required],
      shipToId: null,
      referenceOrderNumber: null,
      incoTerms: null,
      incoTermsDescription: null,
      paymentTermsId: [null, Validators.required],
      fixedPaymentDate: [null, Validators.required],
      cropId: [null, Validators.required],
      deliveryBlock: null,
      internalNote: null,
      customerInvoiceNote: null,
      orderStatusId: null,
      ysapOrderCreattionDate: null,
      isKb: null,
      isPf: null,
      suffixId: 0,
      suffixCheck: false,
      contactPerson: [null],
      contactNumber: [null],
      loadingNotes: null,
      additionalComments: null,
      radius: [null, [Validators.min(0), Validators.max(70)]],
      totalPrice: null,
      approvingUserId: null,
      approvingDate: null,
      customerApprovingId: null,
      customerApprovingDate: null,
      deliveryAddressId: null,
      memberNumberId: null,
      customerOrderNumber: null,
      validToDate: [null, Validators.required],
      coopOrderNumber: null,
      isAltAddress: false,
      isDirectPayer: false,
    });
  }

  ngOnInit(): void {
      this.newOrderForm.get('orderDate').valueChanges.subscribe(value => {
        this.minFixedPaymentDate = value ? dayjs(value).toDate() : null;
      });

      this.cropFilterCtrl.valueChanges.subscribe({
          next: (res) => {
              this.filteredCropList = [...this.cropList.filter(c => {
                  return c.description.toLowerCase().includes(res.toLowerCase())
              })]
          }
      })
    localStorage.removeItem("firstTimeLogin");
    this.nav.toggleLoading(true);
    if(localStorage.getItem('firstTimeLogin')) {
      localStorage.removeItem('firstTimeLogin');
    }

    this.plantSelectionService.clearSelectedPlant();
    //order ID set to route
    this.route.params.subscribe((params) => {
      let id = params['id'];
      this.orderObj.id = id;
    });
    this.routingOrigins = this.route.snapshot.paramMap.get('origins') ? this.route.snapshot.paramMap.get('origins') : null;

    if (this.orderObj.id === undefined) {
      this.updateFormOptionControls();
      setTimeout(() => {
        this.kBChecked = true;
        this.newOrderForm.controls.orderDate.setValue(this.currentDate.format('YYYY-MM-DD'));
        this.isAddItemEnabled = false;
        this.newOrderForm.get('validToDate').disable();
      }, 1000)
      this.nav.toggleLoading(false);
    }

    // setTimeout(() => {
    this.populateTermsListDropDown();
    this.populateCropsListDropDown();
    this.populateCustomerDetails();


    if (this.items) {
      if (this.items?.length == 0) {
        this.newOrderForm.get('soldToId').enable();
        this.newOrderForm.get('payerId').enable();
        this.newOrderForm.get('isDirectPayer').enable();
        this.isCopyOrderEnabled = false;
      } else {
        this.newOrderForm.get('soldToId').disable();
        this.isCopyOrderEnabled = true;
        this.newOrderForm.get('orderDate').disable();
      }
    }


    if (!this.newOrderForm.controls.payerId.value) {
      this.newOrderForm.controls.paymentTermsId.setValue(1);
    } else {
      if (this.selectedPayerCustomer) {
        this.newOrderForm.controls.paymentTermsId.setValue(this.selectedPayerCustomer.paymentTerms.id);
      }

    }
    // }, 1000)


    if (this.orderObj?.id) {
      this.nav.toggleLoading(true);
      this.ordersService.getOrderById(this.orderObj.id)
        .pipe(
          catchError((error) => {
            console.error(error);
            this.router.navigate(['/order-manager/my-orders']);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.orderObj = response;

          //UPDATE FORM CONTROLS
          this.updateFormOptionControls();
          this.newOrderForm.patchValue(response);

          if (response?.orderDate == null) {
            this.newOrderForm.controls.orderDate.setValue(this.currentDate.format('YYYY-MM-DD'));
          } else {
            this.newOrderForm.controls.orderDate.setValue(response.orderDate);
          }

          this.newOrderForm.controls.id.setValue(this.orderObj?.id);

          if (response?.isMobile === true) {
            this.isMobileNoticeVisible = true;
          } else {
            this.isMobileNoticeVisible = false;
          }

          if (response?.orderStatus?.id == this.orderStatusTypeObj?.draftStatus || response?.orderStatus?.id == null) {
            this.isDraft = true;
            this.isEditOrderOptionsEnabled = true;
            this.saveUpdateBtn = this.saveDraftBtn;
            this.submitBtn = this.submitUpdatedBtn;
          } else {
            this.isEditOrderOptionsEnabled = false;
            this.isDraft = false;
          }


          setTimeout(() => {
            this.editOrder();
          }, 500)

          if (this.isEditOrderEnabled == false && this.isEditOrderOptionsEnabled == true) {
            this.isOrderToSapBtnDisabled = false;
          }

          if (response?.isKb === true) {
            this.isKb = true;
            this.newOrderForm.controls['isKb'].setValue(response.isKb);
            this.newOrderForm.controls.validToDate.setValue(this.currentDate.add(1, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'));
            this.newOrderForm.get('validToDate').disable();

          } else {
            this.isPf = true;
            this.newOrderForm.controls['isPf'].setValue(response.isPf);
            this.validToDate = this.currentDate.add(6, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
            this.newOrderForm.get('validToDate').disable();
          }

          if (this.pFChecked == true) {
            this.newOrderForm.controls.paymentTermsId.setValue(8);
          } else if (this.kBChecked == true && response.paymentTerms) {
            this.kBChecked = true;
            this.newOrderForm.controls.paymentTermsId.setValue(this.orderObj.paymentTerms.id);
          }

          setTimeout(() => {
            if (this.pFChecked == true || this.isPf == true) {
              this.newOrderForm.controls.paymentTermsId.setValue(8);
              this.validToDate = this.currentDate.add(6, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
              this.newOrderForm.controls.validToDate.setValue(this.validToDate);
              this.pFChecked = true;
              this.newOrderForm.get('paymentTermsId').disable();
              this.newOrderForm.get('fixedPaymentDate').enable();
              this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
              this.isSuffixVisable = false;
              this.newOrderForm.controls.suffixCheck.setValue(false);
              this.newOrderForm.controls.suffixId.setValue(0);
              this.newOrderForm.get('suffixCheck').disable();
              this.newOrderForm.get('suffixId').disable();
            } else {
              if (this.kBChecked == true || this.isKb == true && response.payer) {
                this.newOrderForm.controls.paymentTermsId.setValue(this.orderObj.paymentTerms.id);
                this.validToDate = this.currentDate.add(1, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
                this.newOrderForm.controls.validToDate.setValue(this.validToDate);
              }
            }

            if (this.isKb == true && this.newOrderForm.controls.paymentTermsId.value == 8) {
              this.isPaymentDateVisable = true;
              this.newOrderForm.get('fixedPaymentDate').enable();
              this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
            } else if (this.isKb == true && this.newOrderForm.controls.paymentTermsId.value !== 8 || this.orderObj.paymentTerms.id !== 8) {
              this.isPaymentDateVisable = false;
              this.newOrderForm.get('fixedPaymentDate').disable();
              this.newOrderForm.controls.fixedPaymentDate.removeValidators(Validators.required);
            }


            if (response?.soldTo) {
              this.newOrderForm.controls.soldToId.setValue(response.soldTo.id);
              this.setSelectedSoldTo(response.soldTo);
              //if not linked to customer in review mode
              if (!this.isEditOrderOptionsEnabled) {
                setTimeout(() => {
                  this.customers.push(response.soldTo);
                  this.newOrderForm.controls.soldToId.setValue(response.soldTo.id);
                  this.setSelectedSoldTo(response.soldTo);
                  this.setInitialSoldToList();
                }, 500)

              }

              //if  APPROVER NOT LINKED  to customer for sold to or payer  in review mode
              if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingManagerApprovalStatus || //3 pending manager approval 
                this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingTermManagerApprovalStatus) { //12 pending term manager approval 

                this.customers.push(response?.soldTo);
                this.customers.push(response?.payer);

                this.newOrderForm.controls.soldToId.setValue(response?.soldTo?.id);
                this.setSelectedSoldTo(response?.soldTo);

                this.newOrderForm.controls.payerId.setValue(response?.payer?.id);
                this.setSelectedPayer(response?.payer, null, null);
              }

              // Set initial sold-to dropdown selected value here
              if (this.customers) {
                this.customers.filter((customer) => {
                  if (customer.id == this.newOrderForm.controls.soldToId.value) {
                    // Set initial selection
                    this.soldToCtrl.setValue(customer);
                    this.setInitialSoldToList();
                  }
                })
              }


              if (response.deliveryAddress) {

                if (this.orderObj.soldTo.address.id == this.orderObj.deliveryAddress.id) {
                  this.isAltCustomerAddressChecked = false;
                  this.newOrderForm.controls.isAltAddress.setValue(false);

                  this.newOrderForm.controls.deliveryAddressId.setValue(null);
                } else {
                  this.orderObj.soldTo.altAddress.forEach((result) => {
                    if (result.id == this.orderObj.deliveryAddress.id) {
                      this.isAltCustomerAddressChecked = true;
                      this.setSelectedAltAddress(this.orderObj.deliveryAddress);
                      this.newOrderForm.controls.deliveryAddressId.setValue(result.id);
                      this.newOrderForm.controls.isAltAddress.setValue(true);
                    }
                  });
                }
              }
            }
          }, 500);

          if (this.isAltCustomerAddressChecked == true) {
            this.newOrderForm.get('deliveryAddressId').enable();
            this.newOrderForm.get('deliveryAddressId').markAsUntouched();
            this.newOrderForm.get('deliveryAddressId').updateValueAndValidity();
          }

          if (this.isAltCustomerAddressChecked == false) {
            this.newOrderForm.get('deliveryAddressId').disable();
            this.newOrderForm.get('deliveryAddressId').markAsUntouched();
            this.newOrderForm.get('deliveryAddressId').updateValueAndValidity();
          }


          if (response?.payer) {
            setTimeout(() => {
              if (this.customers) {
                this.newOrderForm.controls.payerId.setValue(response?.payer?.id);
                this.setSelectedPayer(response.payer);
                //if not linked to customer in review mode
 
                if (!this.isEditOrderOptionsEnabled) {
                    this.customers.push(response.payer);
                  this.newOrderForm.controls.payerId.setValue(response?.payer?.id);
                  this.setSelectedPayer(response.payer);
                  // this.setSelectedPayer(response.payer);
                }

                // Set initial payer dropdown selected value here
                this.customers.filter((customer) => {
                  if (customer.id == this.newOrderForm.controls.payerId.value) {
                    // Set initial selection
                    this.payerCtrl.setValue(customer);
                    this.setInitialPayerList();
                  }
                })

                this.customers.forEach((result) => {
                  if (result?.id == this.orderObj?.soldTo?.id) {
                    this.setSelectedSoldTo(result);
                  }
                  if (result?.id == this.orderObj?.payer?.id) {
                    if (this.orderObj?.payer?.id == this.orderObj?.soldTo?.id) {
                      this.isDirectPayerSelected = true;
                      this.newOrderForm.controls.isDirectPayer.setValue(true);
                    } else {
                      this.isDirectPayerSelected = false;
                      this.newOrderForm.controls.isDirectPayer.setValue(false);
                    }
                  }
                });
              }
            }, 500);
          }


          if (response?.soldTo !== null && response?.payer !== null) {
            this.populateCoOpMemberListDropDown(response.soldTo.tenant.id, response.payer.tenant.id);
          }

          if (response?.memberNumber) {
            this.newOrderForm.controls.memberNumberId.setValue(this.orderObj.memberNumber.id);
          }

          if (response?.coopOrderNumber) {
            this.newOrderForm.controls.coopOrderNumber.setValue(this.orderObj.coopOrderNumber);
          }

          if (response?.crop) {
            this.newOrderForm.controls.cropId.setValue(this.orderObj.crop.id);
          }

          // Load suffix from backend response
          if (response?.suffix?.id && response.suffix?.id !== 0) {
            this.newOrderForm.controls.suffixCheck.setValue(true);
            this.newOrderForm.controls.suffixId.setValue(response.suffix?.id);
            this.isSuffixVisable = true;
            this.populateOrderSuffixListDropDown();
          }

          if (response?.contactPerson) {
            this.newOrderForm.controls.contactPerson.setValue(this.orderObj.contactPerson);
          }

          if (response?.contactNumber) {
            this.newOrderForm.controls.contactNumber.setValue(this.orderObj.contactNumber);
          }

          if (response?.payer) {
            
            if (this.getSGrp(response?.payer).includes('ZAF')) {
              this.isPayerCoop = true;
            }

            if ((response?.soldTo?.id == response?.payer?.id) && (response?.soldTo?.id != null && response?.payer?.id != null)) {
              this.isDirectPayerSelected = true;
              this.newOrderForm.controls.isDirectPayer.setValue(true);
              this.newOrderForm.controls.payerId.setValue(response?.soldTo?.id);
              this.checkPayerValidation();
            }else{
              this.isDirectPayerSelected = false;
              this.newOrderForm.controls.isDirectPayer.setValue(false);
              this.newOrderForm.controls.payerId.setValue(response?.payer?.id);
              this.checkPayerValidation();
            }
          }


          setTimeout(() => {
            if (response?.soldTo && response?.payer) {
              this.isAddItemEnabled = true;
            } else {
              this.isAddItemEnabled = false;
            }
            this.populateNotesLists();
            this.populateAttachmentLists();
            this.populateItemsLists();
          }, 500);


          if (response?.orderApprovalMessage) {
            this.showNotice = true;

            this.approvalMessage = response.orderApprovalMessage;
            const messageArr: string[] = this.approvalMessage.split(';').map(str => str.trim());
            this.approvalMessageSplit = messageArr;

          } else {
            this.showNotice = false;
          }


          if (this.approvalMessageSplit[0] && this.approvalMessageSplit[1] ||
            this.approvalMessageSplit[0] && this.approvalMessageSplit[2] ||
            this.approvalMessageSplit[1] && this.approvalMessageSplit[2]) {
            this.showNoticeSplitterOne = true;
          }

          if (this.approvalMessageSplit[1] && this.approvalMessageSplit[2] ||
            this.approvalMessageSplit[0] && this.approvalMessageSplit[2]) {
            this.showNoticeSplitterTwo = true;
          }

          this.nav.toggleLoading(false);
          setTimeout(() => {
            this.isUpdating = false;
          }, 1500)
        });


    }

    this.nav.toggleLoading(false);
  }

  ngOnDestroy() {
    this._onPayerDestroy.next();
    this._onPayerDestroy.complete();
    this._onSoldToDestroy.next();
    this._onSoldToDestroy.complete();
    this._onAltAddressDestroy.next();
    this._onAltAddressDestroy.complete();
    this._onMemberNumberDestroy.next();
    this._onMemberNumberDestroy.complete();
  }

  ngAfterContentInit() {
    this.maxDate = dayjs(this.orderDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
  }

  /**
   * Method that sets the intial payer list that will be displayed in the payer dropdown.
   */
  setInitialPayerList() {
    // Load the initial payer list
    this.filteredPayers.next(this.customers.slice());
    // Listen for search field value changes
    this.payerFilterCtrl.valueChanges
      .pipe(takeUntil(this._onPayerDestroy))
      .subscribe(() => {
        this.filterPayers();
      });
  }

  /**
 * Method that sets the intial payer list that will be displayed in the payer dropdown.
 */
  setInitialSoldToList() {
    // Load the initial sold to list
    this.filteredSoldTos.next(this.customers.slice());
    // Listen for search field value changes
    this.soldToFilterCtrl.valueChanges
      .pipe(takeUntil(this._onSoldToDestroy))
      .subscribe(() => {
        this.filterSoldTos();
      });
  }

  /**
   * Method that sets the intial altAddress list that will be displayed in the payer dropdown.
   */
  setInitialAltAddressList() {
    // Load the initial alt address list
    this.filteredAltAddresses.next(this.selectedSoldToCustomer.altAddress.slice());
    // Listen for search field value changes
    this.altAddressFilterCtrl.valueChanges
      .pipe(takeUntil(this._onAltAddressDestroy))
      .subscribe(() => {
        this.filterAltAddresses();
      });
  }

  /**
   * Method that sets the intial payer list that will be displayed in the payer dropdown.
   */
  setInitialMemberNumberList() {
    // Load the initial member number list
    this.filteredMemberNumbers.next(this.coOpMemberList.slice());
    // Listen for search field value changes
    this.memberNumberFilterCtrl.valueChanges
      .pipe(takeUntil(this._onMemberNumberDestroy))
      .subscribe(() => {
        this.filterMemberNumbers();
      });
  }

  protected filterPayers() {
    if (!this.customers) {
      return;
    }
    // Get the search keyword
    let search = this.payerFilterCtrl.value;
    if (!search) {
      this.filteredPayers.next(this.customers.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter the payers based on the search keyword
    this.filteredPayers.next(
      this.customers.filter(payer => payer.name.toLowerCase().indexOf(search) > -1 || payer.ysapCode.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterSoldTos() {
    if (!this.customers) {
      return;
    }
    // Get the search keyword
    let search = this.soldToFilterCtrl.value;
    if (!search) {
      this.filteredSoldTos.next(this.customers.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filter the Sold To's based on the search keyword
    this.filteredSoldTos.next(
      this.customers.filter(soldTo => soldTo.name.toLowerCase().indexOf(search) > -1 || soldTo.ysapCode.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterAltAddresses() {
    if (!this.selectedSoldToCustomer?.altAddress) {
      return;
    }
    // Get the search keyword
    let search = this.altAddressFilterCtrl.value;
    if (!search) {
      this.filteredAltAddresses.next(this.selectedSoldToCustomer.altAddress.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filter the Sold To's based on the search keyword
    this.filteredAltAddresses.next(
      this.selectedSoldToCustomer.altAddress.filter(address => address.addressLine1?.toString().toLowerCase().indexOf(search) > -1 ||
        address.addressLine2?.toString().toLowerCase().indexOf(search) > -1 ||
        address.addressLine3?.toString().toLowerCase().indexOf(search) > -1 ||
        address.province?.toLowerCase().indexOf(search) > -1 ||
        address.town?.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterMemberNumbers() {
    if (!this.coOpMemberList) {
      return;
    }
    // Get the search keyword
    let search = this.memberNumberFilterCtrl.value;
    if (!search) {
      this.filteredMemberNumbers.next(this.coOpMemberList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filter the Sold To's based on the search keyword
    this.filteredMemberNumbers.next(
      this.coOpMemberList.filter(memberNumber => memberNumber.memberNumber.toLowerCase().indexOf(search) > -1)
    );
  }

  //// DROP DOWN ////
  populateTermsListDropDown() {
    this.metadataService
      .getTermsList()
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.availableTermList = response;
      });
  }

  populateCropsListDropDown() {
    this.metadataService
      .getCropsList()
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.cropList = response.sort((a, b) => a.description.localeCompare(b.description));
        this.filteredCropList = [...this.cropList];
      });
  }

  populateCoOpMemberListDropDown(soldToTenantId: number, payerTenantId: number) {

    if ((this.selectedSoldToCustomer && this.selectedPayerCustomer) ||
      (this.orderObj.soldTo && this.orderObj.payer)) {
      this.coOpMemberService.getCoOpMemberList(soldToTenantId, payerTenantId)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.coOpMemberList = response;
          this.setInitialMemberNumberList();
        });
    }
  }

  populateCustomerDetails() {
    this.customerService
      .getCustomerDetails()
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.customers = this.customers.concat(response);

        // If the payer is not selected set the initial dropdown list to what is available.
        this.setInitialPayerList();
        this.setInitialSoldToList();
      });
  }

    populateOrderSuffixListDropDown() {
    let currentDate = dayjs().format('YYYY-MM-DDTHH:mm:ss');
    this.metadataService.getOrderSuffixList(currentDate)
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        const noneOption = {
          id: 0,
          description: 'None',
          suffixCode: '',
          startDate: '',
          endDate: '',
          dateCreated: '',
          isActive: false,
          isDeleted: false,
        } as OrderSuffixModel;
        this.orderSuffixListList = [noneOption, ...response.sort((a, b) => a.description.localeCompare(b.description))];
        
        // Set selectedSuffix from form value if it exists
        const currentSuffixId = this.newOrderForm.controls.suffixId.value;
        if (currentSuffixId) {
          this.selectedSuffix = this.orderSuffixListList.find(s => s.id === currentSuffixId);
        }
      });
  }

  setOrderSuffixCode(suffix: OrderSuffixModel) {
    this.selectedSuffix = suffix;
    this.newOrderForm.controls.suffixId.setValue(suffix?.id || 0);
  }




  updateAltAddressDetails() {
    this.customerService.getCustomerDetails()
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.customers = response;

        if (this.selectedSoldToCustomer) {
          for (let customer of this.customers) {
            if (this.selectedSoldToCustomer?.id == customer?.id) {
              this.selectedSoldToCustomer = customer;
            }
          }

          for (let altAddressItem of this.selectedSoldToCustomer?.altAddress) {
            if (this.altAddress?.id == altAddressItem?.id) {
              this.altAddress = altAddressItem;
            }
          }
        }
      });
  }

  //// SET DETAILS ////
  setSelectedSoldTo(customer: CustomerModel) {
    this.selectedSoldToCustomer = customer;
    this.setInitialAltAddressList();

    if (customer?.altAddress) {
      this.selectedSoldToCustomer.altAddress = customer.altAddress;
    }
    this.isCustomerSelected = true;
    this.setCustomerContact(this.selectedSoldToCustomer);

    setTimeout(() => {
      if (this.selectedPayerCustomer) {
        this.populateCoOpMemberListDropDown(customer.tenant.id, this.selectedPayerCustomer.tenant.id);
      }
    }, 500)


    // if direct payer is checked, update payer to match the newly selected sold-to
    if (this.isDirectPayerSelected) {
      this.selectedPayerCustomer = customer;
      this.newOrderForm.controls.payerId.setValue(customer.id);
      // Update co-op visibility based on new payer's sGrp
      this.isPayerCoop = this.getSGrp(customer).includes('ZAF');
      if (!this.isPayerCoop) {
        this.newOrderForm.get('coopOrderNumber').removeValidators(Validators.required);
        this.newOrderForm.get('coopOrderNumber').updateValueAndValidity();
      }
    }
  }
  setCustomerContact(customer: CustomerModel) {
    if (this.newOrderForm.controls.contactPerson.value === null || this.newOrderForm.controls.contactNumber.value === null) {
      this.newOrderForm.controls.contactPerson.setValue(this.selectedSoldToCustomer.contactUser.name);
      this.newOrderForm.controls.contactNumber.setValue(this.selectedSoldToCustomer.contactUser.cell);
    } else if (customer?.id !== this.orderObj?.soldTo?.id) {
      this.newOrderForm.controls.contactPerson.setValue(this.selectedSoldToCustomer.contactUser.name);
      this.newOrderForm.controls.contactNumber.setValue(this.selectedSoldToCustomer.contactUser.cell);
    }

  }


  //check for changes in customer
  customerChangeDetect(customer: CustomerModel, event: any){
    if(event?.isUserInput){
     this.selectedPayerCustomer = customer;
     this.onPayerKeydown( this.selectedPayerCustomer, event);
    }
  }

  // payer click
  onPayerClick(customer: CustomerModel, event: MouseEvent) {
  this.setSelectedPayer(customer, event, null);
}

//payer enter key
onPayerKeydown(customer: CustomerModel, event: KeyboardEvent) {
 this.setSelectedPayer(customer,  null, event);
}
 
  setSelectedPayer( customer: CustomerModel, clickEvent?: MouseEvent | null, keyEvent?: KeyboardEvent | null) {
    this.selectedPayerCustomer = customer;
    this.isCustomerSelected = true;

    // Auto-check/uncheck direct payer based on payer matching sold-to
    if (this.selectedSoldToCustomer && this.selectedPayerCustomer &&
      this.selectedSoldToCustomer.id === this.selectedPayerCustomer.id) {
      this.isDirectPayerSelected = true;
      this.newOrderForm.controls.isDirectPayer.setValue(true);
    } else {
      this.isDirectPayerSelected = false;
      this.newOrderForm.controls.isDirectPayer.setValue(false);
    }

    // PF always forces term to 8 with fixed payment date enabled
    if (this.isPf || this.pFChecked) {
      this.newOrderForm.controls.paymentTermsId.setValue(8);
      this.isPaymentDateVisable = true;
      this.newOrderForm.get('fixedPaymentDate').enable();
      this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
    } else if (!this.isUpdating && this.selectedPayerCustomer) {
      // KB: always set term to payer's default
      this.selectedTerm = this.selectedPayerCustomer.paymentTerms;
      this.newOrderForm.controls.paymentTermsId.setValue(this.selectedTerm.id);

      if (this.selectedTerm.id == 8) {
        this.isPaymentDateVisable = true;
        this.newOrderForm.get('fixedPaymentDate').enable();
        this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
      } else {
        this.newOrderForm.controls.fixedPaymentDate.setValue(null);
        this.newOrderForm.get('fixedPaymentDate').disable();
        this.newOrderForm.controls.fixedPaymentDate.removeValidators(Validators.required);
        this.isPaymentDateVisable = false;
      }
    }

    if (!this.isPf && !this.pFChecked) {
      this.newOrderForm.get('paymentTermsId').enable();
    }

// iF CoOP Member BASED ON PAYER
    if (!this.getSGrp(customer).includes('ZAF') && this.newOrderForm.controls.payerId.value !== null
      || !this.getSGrp(this.selectedPayerCustomer).includes('ZAF') && this.newOrderForm.get('coopOrderNumber').value !== '') {
      this.newOrderForm.get('coopOrderNumber').removeValidators(Validators.required);
      this.newOrderForm.get('coopOrderNumber').setErrors({ required: false });
      this.newOrderForm.get('coopOrderNumber').markAsUntouched();
      this.newOrderForm.get('coopOrderNumber').updateValueAndValidity();
      this.isPayerCoop = false;

    } else if (customer && this.getSGrp(this.selectedPayerCustomer).includes('ZAF') && this.newOrderForm.get('coopOrderNumber').value === null
      || customer && this.getSGrp(this.selectedPayerCustomer).includes('ZAF') && this.newOrderForm.get('coopOrderNumber').value === '') {
      this.isPayerCoop = true;
    }
    else {
      this.isPayerCoop = true;
    }

    if(!this.isUpdating && this.selectedPayerCustomer?.id !== this.orderObj?.payer?.id){
      this.newOrderForm.controls.coopOrderNumber.setValue(null);
      this.newOrderForm.controls.memberNumberId.setValue(0);
      this.saveDraft();
    }
 //IF PAYER CHANGES AFTER ITEMS HAVE BEEN ADDED

      if (!this.isUpdating && (this.selectedPayerCustomer?.id !== this.orderObj?.payer?.id //NOT THE SAME AS LAST SAVED PAYER
        || customer !== this.selectedPayerCustomer &&
        this.selectedPayerCustomer?.id !== this.orderObj?.soldTo?.id && //NOT = TO SOLD TO
        this.selectedPayerCustomer?.id !== 0 && this.newOrderForm.controls.isDirectPayer.value == false)){  //NOT NULL
          this.selectedPayerCustomer = customer;
          this.isDirectPayerSelected = false;
          this.newOrderForm.controls.isDirectPayer.setValue(false);
          this.newOrderForm.controls.payerId.setValue(this.selectedPayerCustomer?.id);
          this.saveDraft();
          this.refreshBrowser();
      }
        this.checkPayerValidation();
  }

  setSelectedTerm(term: TermsModel) {
    this.selectedTerm = term;

    if (this.isPf == true) {
      this.isPf = true;
    }

    if (this.isKb == true && this.newOrderForm.controls.paymentTermsId.value == 8 || term.id == 8) {
      this.isPaymentDateVisable = true;
      this.newOrderForm.get('fixedPaymentDate').enable();
      this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
    } else {
      this.isPaymentDateVisable = false;
      this.newOrderForm.controls.fixedPaymentDate.setValue(null);
      this.newOrderForm.get('fixedPaymentDate').disable();
      this.newOrderForm.controls.fixedPaymentDate.removeValidators(Validators.required);
    }

    this.changeDetectiondTerms.detectChanges();
  }

  // update then get all available order details
  saveDraft() {
    this.nav.toggleLoading(true);
      this.updateOrderFormDetails();
    // }

    if (this.isEditOrderEnabled == false && this.isEditOrderOptionsEnabled == true) {
      this.isOrderToSapBtnDisabled = true;
    }
  }


  //Click To enable editing again on order
  editSubmittedToSapOrder() {

    // Clear legacy fixedPaymentDate if it precedes orderDate to avoid blocking edit mode
    const fixedDate = this.newOrderForm.controls.fixedPaymentDate.value;
    const orderDate = this.newOrderForm.controls.orderDate.value;
    if (fixedDate && orderDate && dayjs(fixedDate).isBefore(dayjs(orderDate), 'day')) {
      this.newOrderForm.controls.fixedPaymentDate.setValue(null);
    }

    if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.submittedToSapStatus || // 8 submitted to sap
      this.orderObj.orderStatus.id == this.orderStatusTypeObj.sapSubmitFailed || // 9 Sap sub failed
      this.orderObj.orderStatus.id == this.orderStatusTypeObj.updatedSubmitedToSapStatus // 11 Updated submit to sap){
    ) {

      this.snackBar.open("You are about to edit this order", "close", {
        duration: 5000,
      });
      this.orderCurrentStatus = this.orderStatusTypeObj.editSubmitedToSapStatus; // 10
      this.updateOrderFormDetails();
      this.editOrder();
      this.orderValidation();
    }

    else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.rejectedStatus || // 5 rejected
      this.orderObj.orderStatus.id == this.orderStatusTypeObj.clienrRejectedStatus || // 7 client rejected
      this.orderObj.orderStatus.id == this.orderStatusTypeObj.recalledStatus) { // 13 recalled
      this.snackBar.open("You are about to edit this order", "close", {
        duration: 5000,
      });
      this.orderCurrentStatus = this.orderStatusTypeObj.draftStatus; // 1
      this.updateOrderFormDetails();
      this.editOrder();
      this.orderValidation();
    }
    this.refreshBrowser();
  }

  disableOrderEditing() {
    this.newOrderForm.get('soldToId').disable();
    this.newOrderForm.get('radius').disable();
    this.newOrderForm.get('contactPerson').disable();
    this.newOrderForm.get('contactNumber').disable();
    this.newOrderForm.get('payerId').disable();
    this.newOrderForm.get('customerOrderNumber').disable();
    this.newOrderForm.get('coopOrderNumber').disable();
    this.newOrderForm.get('memberNumberId').disable();
    this.newOrderForm.get('paymentTermsId').disable();
    this.newOrderForm.get('fixedPaymentDate').disable();
    this.newOrderForm.get('orderDate').disable();
    this.newOrderForm.get('validToDate').disable();
    this.newOrderForm.get('cropId').disable();
    this.newOrderForm.get('isAltAddress').disable();
    this.newOrderForm.get('isDirectPayer').disable();
    this.newOrderForm.get('loadingNotes').disable();
    this.newOrderForm.get('additionalComments').disable();
    this.newOrderForm.get('suffixId').disable();
    this.newOrderForm.get('suffixCheck').disable();

    if (this.newOrderForm.controls.isAltAddress.value == false) {
      this.newOrderForm.get('deliveryAddressId').disable();
    }
    // 
  }

  enableOrderediting() {
    // this.newOrderForm.get('soldToId').enable();
    this.newOrderForm.get('radius').enable();
    this.newOrderForm.get('contactPerson').enable();
    this.newOrderForm.get('contactNumber').enable();
    // this.newOrderForm.get('payerId').enable();
    this.newOrderForm.get('customerOrderNumber').enable();
    this.newOrderForm.get('coopOrderNumber').enable();
    this.newOrderForm.get('memberNumberId').enable();
    if (!this.isPf) {
      this.newOrderForm.get('paymentTermsId').enable(); // was removed - now re-introduced to be editable after sap submission only if not PF
    }
    this.newOrderForm.get('fixedPaymentDate').enable();

    if (!this.newOrderForm.controls.payerId.value) {
      this.newOrderForm.get('paymentTermsId').disable();
      this.newOrderForm.get('fixedPaymentDate').disable();
    }
    // this.newOrderForm.get('orderDate').enable();
    this.newOrderForm.get('cropId').enable();
    this.newOrderForm.get('isAltAddress').enable();
    // this.newOrderForm.get('isDirectPayer').enable();
    this.newOrderForm.get('loadingNotes').enable();
    this.newOrderForm.get('additionalComments').enable();

    if (!this.isPf && !this.pFChecked) {
      this.newOrderForm.get('suffixId').enable();
      this.newOrderForm.get('suffixCheck').enable();
    }

    if (this.newOrderForm.controls.isAltAddress.value == true) {
      this.newOrderForm.get('deliveryAddressId').enable();
    }

  }

  editOrder() {

    setTimeout(() => {
      // DRAFT ONLY: ENABLE EDITING AND SET TEXT TO SAVE AND SUBMIT TO SAP BTN
      if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.draftStatus) { // STATUS : 1
        this.isEditOrderEnabled = false;
        this.isEditOrderOptionsEnabled = true;
        this.saveUpdateBtn = this.saveDraftBtn;
        this.submitBtn = this.submitToSapBtn;
        this.enableOrderediting();
      }
      //ANY EDITABLE STATUSES: ENABLE EDIT BTN AND SET TEXT TO UPDATE AND  SUBMIT UPDATE BTN - STATUS WIL SET TO 10 AFTER CLICK
      else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.submittedToSapStatus || //8
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.sapSubmitFailed || // 9
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.updatedSubmitedToSapStatus // 11
      ) {
        this.isEditOrderEnabled = true;
        this.isEditOrderOptionsEnabled = false;
        this.disableOrderEditing();
      }
      // STATUS 10 ONLY: editSubmitedToSapStatus -  DISABLE EDIT BTN, ENABLE FIELDS TO BE EDITABLE AND SET TEXT TO UPDATE AND  SUBMIT UPDATE BTN - ALWAYS SEND STATUS 2 AFTER SUBMIT/UPDATE
      else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.editSubmitedToSapStatus) { // STATUS : editSubmitedToSapStatus - 10
        this.isEditOrderEnabled = false;
        this.isEditOrderOptionsEnabled = true;
        this.saveUpdateBtn = this.updateOrderBtn;
        this.submitBtn = this.submitUpdatedBtn;
        this.enableOrderediting();
        this.isOrderToSapBtnDisabled = false;
      }

      //IF REJECTED + CLIENT REJECTED + RECALLED: SHOW EDIT BTN, DISABLE FIELDS - STATUS WILL SET TO DRAFT (1) AFTER EDIT CLICK
      else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.rejectedStatus || // 5
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.clienrRejectedStatus || // 7
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.recalledStatus // 13
      ) {
        this.isEditOrderEnabled = true;
        this.isEditOrderOptionsEnabled = false;
        this.disableOrderEditing();
      }

      // DISABLE EDITING OPTION & DISABLE FIELDS
      else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.submittedStatus || // 2
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.pendingManagerApprovalStatus || //3 pending manager approval
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.approvedStatus || // 4 approved
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.clientApprovalStatus || // client approved
        this.orderObj.orderStatus.id == this.orderStatusTypeObj.pendingTermManagerApprovalStatus
      ) {
        this.isEditOrderEnabled = false;
        this.isEditOrderOptionsEnabled = false;
        this.disableOrderEditing();
      }
    }, 300)

  }


  updateOrderFormDetails() {

    if (this.orderCurrentStatus == this.orderStatusTypeObj?.draftStatus || this.orderCurrentStatus == null) {
      this.orderCurrentStatus = this.orderStatusTypeObj?.draftStatus;

    } else if (this.orderCurrentStatus == this.orderStatusTypeObj?.submittedToSapStatus) {
      this.orderCurrentStatus = this.orderStatusTypeObj.submittedToSapStatus;

    } else if (this.orderCurrentStatus == this.orderStatusTypeObj?.editSubmitedToSapStatus) {
      this.orderCurrentStatus = this.orderStatusTypeObj.editSubmitedToSapStatus;

    } else {
      this.orderCurrentStatus = this.orderObj?.orderStatus?.id;
    }

    this.fixedPaymentDate = null;

    //FORMAT SELECTABLE DATES TO AVOID DATE MISSMATCH BY ONE DAY OFF IN PAYLOAD
    if (this.newOrderForm.controls.fixedPaymentDate.value !== null) {
      this.fixedPaymentDate = dayjs(this.newOrderForm.controls.fixedPaymentDate.value).format('YYYY-MM-DD');
    }

    // DO NOT ADD THH:mm:ss.SSSZ to the ORDER Date, This will break the order update
    const formattedOrdertDate = dayjs(this.newOrderForm.controls.orderDate.value).format('YYYY-MM-DD') + "T00:00:00.000+00:00";
    // const formattedOrdertDate = dayjs(this.newOrderForm.controls.orderDate.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    const formattedValidTotDate = dayjs(this.newOrderForm.controls.validToDate.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    let currentDeliveryAddressId:number = null;
   
    if(this.selectedSoldToCustomer?.address?.id && !this.isAltCustomerAddressChecked){
        currentDeliveryAddressId = this.selectedSoldToCustomer?.address?.id;
    }
     if(this.newOrderForm.controls?.deliveryAddressId?.value && this.isAltCustomerAddressChecked){
        currentDeliveryAddressId = this.newOrderForm.controls?.deliveryAddressId?.value
    }

    let updatedOrderForm = {
      id: this.orderObj.id,
      orderType: this.newOrderForm.controls.orderType.value,
      salesOrg: this.orderObj.salesOrg,
      salesOffice: this.orderObj.salesOffice,
      distributionChannel: this.orderObj.distributionChannel,
      division: this.orderObj.division,
      orderDate: formattedOrdertDate,
      currency: this.orderObj.currency,
      pricingDate: this.newOrderForm.controls.pricingDate.value,
      soldToId: this.newOrderForm.controls.soldToId.value,
      billToId: this.newOrderForm.controls.payerId.value,
      payerId: this.newOrderForm.controls.payerId.value,
      shipToId: this.newOrderForm.controls.soldToId.value,
      referenceOrderNumber: this.newOrderForm.controls.referenceOrderNumber.value,
      incoTerms: this.orderObj.incoTerms,
      incoTermsDescription: this.orderObj.incoTermsDescription,
      paymentTermsId: this.newOrderForm.controls.paymentTermsId.value,
      fixedPaymentDate: this.fixedPaymentDate,
      cropId: this.newOrderForm.controls.cropId.value,
      deliveryBlock: this.newOrderForm.controls.deliveryBlock.value,
      internalNote: this.newOrderForm.controls.internalNote.value,
      customerInvoiceNote: this.newOrderForm.controls.customerInvoiceNote.value,
      orderStatusId: this.orderCurrentStatus,
      ysapOrderCreattionDate: this.newOrderForm.controls.ysapOrderCreattionDate.value,
      isKb: this.isKb,
      isPf: this.isPf,
      suffixId: this.newOrderForm.controls.suffixId.value || 0,
      contactPerson: this.newOrderForm.controls.contactPerson.value,
      contactNumber: this.newOrderForm.controls.contactNumber.value,
      loadingNotes: this.newOrderForm.controls.loadingNotes.value,
      additionalComments: this.newOrderForm.controls.additionalComments.value,
      radius: this.newOrderForm.controls.radius?.value ?? 0,
      totalPrice: this.newOrderForm.controls.totalPrice.value,
      approvingUserId: this.newOrderForm.controls.approvingUserId.value,
      approvingDate: this.newOrderForm.controls.approvingDate.value,
      customerApprovingId: this.newOrderForm.controls.customerApprovingId.value,
      customerApprovingDate: this.newOrderForm.controls.customerApprovingDate.value,
      deliveryAddressId: currentDeliveryAddressId,
      memberNumberId: this.newOrderForm.controls.memberNumberId.value,
      customerOrderNumber: this.newOrderForm.controls.customerOrderNumber.value,
      validToDate: formattedValidTotDate,
      coopOrderNumber: this.newOrderForm.controls.coopOrderNumber.value,
    };

    this.nav.toggleLoading(true);

    if (this.fixedPaymentDate) {
      const orderDate = dayjs(this.newOrderForm.controls.orderDate.value);
      const paymentDate = dayjs(this.fixedPaymentDate);
      if (paymentDate.isBefore(orderDate, 'day')) {
        this.nav.toggleLoading(false);
        this.snackBar.open("Fixed payment date cannot be before the order date. Please update the payment date.", "close", {
          duration: 8000,
        });
        return;
      }
    }

    this.ordersService.updateOrderForm(updatedOrderForm)
      .pipe(
        catchError((error) => {
          console.error(error);
          this.nav.toggleLoading(false);
          this.snackBar.open("Failed to save order. Please check your inputs.", "close", {
            duration: 5000,
          });
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.ordersDto = response;
        this.ordersService.getOrderById(this.orderObj.id)
          .pipe(
            catchError((error) => {
              console.error(error);
              return throwError(() => error);
            })
          )
          .subscribe((response) => {
            this.updatedOrderObj = response;

            setTimeout(() => {
              if (response?.soldTo && response?.payer) {
                this.isAddItemEnabled = true;
              } else {
                this.isAddItemEnabled = false;
              }
            }, 500);

            this.nav.toggleLoading(false);

          });

      });
  }

  checkRadiusValue() {
    if (!this.newOrderForm.controls['radius'].value || this.newOrderForm.controls['radius'].value < 0) {
      this.newOrderForm.controls['radius'].setValue(0);
    }
  }

  openSubmitToSapDialog() {
    this.orderValidation();
    this.checkCoOpValidation();
    this.checkFixedPaymentDateValidation();

    if (this.newOrderForm.valid && this.items) {
      if (this.items.length === 0) {
        this.snackBar.open("Please add at least one item to continue", "close", {
          duration: 5000,
        });
      }

    }

    if (this.newOrderForm.valid && this.items.length !== 0) {
      this.submittedToSap = true;

      if (this.items.length !== 0) {
        if (this.discountValidationItems.some(item => item.inDiscountLevel === false)) {
          this.discountExceeded = 'YES';
          this.totalDiscount = 'YES';
        } else {
          this.discountExceeded = 'NO';
          this.totalDiscount = 'NO';
        }
      }

      let paymentTermId = this.newOrderForm.controls.paymentTermsId.value;
      let payerPaymentTermId = this.newOrderForm.controls.payerId.value;

      let paymentTerm = this.availableTermList.find(a => a.id === paymentTermId);
      let payerPaymentTerm = this.customers.find(b => b.id === payerPaymentTermId);

      this.termsExceeded = paymentTerm.days <= payerPaymentTerm.paymentTerms.days ? 'NO' : 'YES';

      const dialogRef = this.submitToSapDialog.open(SubmitToSapComponent, {
        data: {
          orderId: this.orderObj.displayOrderNumber ?? this.orderObj.orderNumber,
          orderDate: this.newOrderForm.controls.orderDate.value,
          inDiscountLev: this.discountExceeded,
          totalDisc: this.totalDiscount,
          termsExceeded: this.termsExceeded,
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.isSubmit == true) {
          this.submittedToSap = true;
          this.submitOrderToSap();
        }
      });
    } else {
      this.submittedToSap = false;
      this.orderValidation();

    }

  }

  orderValidation() {

    if (this.newOrderForm.invalid) {

      if (this.newOrderForm.controls.soldToId.value == null
        || this.newOrderForm.controls.payerId.value == null
        || this.newOrderForm.controls.paymentTermsId.value === null
        || this.newOrderForm.controls.fixedPaymentDate.value == null
        || this.newOrderForm.controls.orderDate.value === null
        || this.newOrderForm.controls.validToDate.value == null
        || this.newOrderForm.controls.cropId.value == null) {

        this.newOrderForm.get('soldToId').setErrors({ required: true });
        this.newOrderForm.get('soldToId').markAsTouched();
        this.newOrderForm.get('soldToId').updateValueAndValidity();

        this.newOrderForm.get('payerId').setErrors({ required: true });
        this.newOrderForm.get('payerId').markAsTouched();
        this.newOrderForm.get('payerId').updateValueAndValidity();

        this.newOrderForm.get('paymentTermsId').setErrors({ required: true });
        this.newOrderForm.get('paymentTermsId').markAsTouched();
        this.newOrderForm.get('paymentTermsId').updateValueAndValidity();

        this.newOrderForm.get('orderDate').setErrors({ required: true });
        this.newOrderForm.get('orderDate').markAsTouched();
        this.newOrderForm.get('orderDate').updateValueAndValidity();

        this.newOrderForm.get('validToDate').setErrors({ required: true });
        this.newOrderForm.get('validToDate').markAsTouched();
        this.newOrderForm.get('validToDate').updateValueAndValidity();

        this.newOrderForm.get('cropId').setErrors({ required: true });
        this.newOrderForm.get('cropId').markAsTouched();
        this.newOrderForm.get('cropId').updateValueAndValidity();

        this.snackBar.open("Please check all required fields to continue", "close", {
          duration: 5000,
        });
      }
      this.checkCoOpValidation();

      if (this.newOrderForm.valid && this.items.length === 0) {
        this.snackBar.open("Please add at least one item to continue", "close", {
          duration: 5000,
        });
        this.isCopyOrderEnabled = false;
      }
    }

  }


  submitOrderToSap() {

    if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.draftStatus ||
      this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.recalledStatus ||
      this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.editSubmitedToSapStatus
    ) {

      //FORMAT SELECTABLE DATES TO AVOID DATE MISSMATCH BY ONE DAY OFF IN PAYLOAD 
      if (this.newOrderForm.controls.fixedPaymentDate.value !== null) {
        this.fixedPaymentDate = dayjs(this.newOrderForm.controls.fixedPaymentDate.value).format('YYYY-MM-DD');
      }
      this.newOrderForm.patchValue({
        orderStatusId: this.orderStatusTypeObj.submittedStatus,
        fixedPaymentDate: this.fixedPaymentDate,
      });

    }

    if (this.submittedToSap === true) {
      if (this.newOrderForm.valid && this.items.length !== 0) {

        this.nav.toggleLoading(true);

        this.newOrderForm.patchValue({
          orderDate: dayjs(this.newOrderForm.controls.orderDate.value).format('YYYY-MM-DD') + "T00:00:00.000+00:00"
        });

        this.ordersService.updateOrderForm(this.newOrderForm.getRawValue())
          .pipe(
            catchError((error) => {
              console.error(error);
              return throwError(() => error);
            })
          )
          .subscribe((response) => {
            this.ordersService.getOrderById(this.orderObj.id)
              .pipe(
                catchError((error) => {
                  console.error(error);
                  return throwError(() => error);
                })
              )
              .subscribe((response) => {
                this.updatedOrderObj = response;
                // this.refreshBrowser();
                this.nav.toggleLoading(false);
              });
            this.refreshBrowser();
          });
      }
    }
  }

  kBCheck() {
    this.isKb = true;
    this.isPf = false;

    this.newOrderForm.controls['isKb'].setValue(true);
    this.newOrderForm.controls['isPf'].setValue(false);

    this.newOrderForm.get('suffixCheck').enable();
    this.newOrderForm.get('suffixId').enable();

    if (!this.newOrderForm.controls.payerId.value) {
      this.newOrderForm.controls.paymentTermsId.setValue(1);
    } else {
      if (this.selectedPayerCustomer) {
        this.newOrderForm.controls.paymentTermsId.setValue(this.selectedPayerCustomer.paymentTerms.id);
      }
    }

    this.pFChecked = false;
    this.isPaymentDateVisable = false;
    this.newOrderForm.controls.fixedPaymentDate.setValue(null);

    if (this.selectedPayerCustomer) {
      this.selectedTerm = this.selectedPayerCustomer.paymentTerms;
    }

    if (this.kBChecked == true || this.isKb == true) {
      this.newOrderForm.get('paymentTermsId').enable();
      this.newOrderForm.get('fixedPaymentDate').disable();

      if (!this.newOrderForm.controls.payerId.value) {
        this.newOrderForm.get('paymentTermsId').disable();
      }

      if (!this.newOrderForm.controls.validToDate.value || this.kBChecked == true) {
        this.validToDate = this.currentDate.add(1, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        this.newOrderForm.controls.validToDate.setValue(this.validToDate);

      } else if (this.newOrderForm.controls.validToDate.value !== null) {
        this.validToDate = this.currentDate.add(1, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        this.newOrderForm.controls.validToDate.setValue(this.validToDate);
      }

      if (this.isKb == true && this.newOrderForm.controls.paymentTermsId.value == 8 || this.selectedTerm.id == 8) {
        this.isPaymentDateVisable = true;
        this.newOrderForm.get('fixedPaymentDate').enable();
        this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
      } else {
        this.isPaymentDateVisable = false;
        this.newOrderForm.get('fixedPaymentDate').disable();
        this.newOrderForm.controls.fixedPaymentDate.removeValidators(Validators.required);
      }
    }

  }
  pFCheck() {
    this.populateTermsListDropDown();
    this.isKb = false;

    this.isSuffixVisable = false;
    this.newOrderForm.controls.suffixCheck.setValue(false);
    this.newOrderForm.controls.suffixId.setValue(0);
    this.selectedSuffix = null;
    this.newOrderForm.get('suffixCheck').disable();
    this.newOrderForm.get('suffixId').disable();
    this.newOrderForm.controls.paymentTermsId.setValue(8);
    this.pFChecked = true;
    this.isPf = true;

    this.newOrderForm.controls['isKb'].setValue(false);
    this.newOrderForm.controls['isPf'].setValue(true);

    if (this.pFChecked == true || this.isPf == true) {
      this.validToDate = this.currentDate.add(6, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
      this.newOrderForm.controls.validToDate.setValue(this.validToDate);
      this.newOrderForm.get('paymentTermsId').disable();
      this.newOrderForm.get('fixedPaymentDate').enable();
      this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
      this.newOrderForm.get('fixedPaymentDate').updateValueAndValidity();

      if (this.orderObj.fixedPaymentDate) {
        this.newOrderForm.controls.fixedPaymentDate.setValue(this.orderObj.fixedPaymentDate);
      }
    }
  }

  suffixSpecialCheck(){
    this.isSuffixVisable = !this.isSuffixVisable;
    if (!this.isSuffixVisable) {
      this.newOrderForm.controls.suffixId.setValue(0);
      this.selectedSuffix = null;
    }
    this.populateOrderSuffixListDropDown();
  }

  altAddressChecked() {
    this.isAltCustomerAddressChecked = !this.isAltCustomerAddressChecked;

    if (this.isAltCustomerAddressChecked && this.selectedSoldToCustomer?.id) {
      this.newOrderForm.controls.deliveryAddressId.setValue(this.newOrderForm.controls.deliveryAddressId.value);
      this.setInitialAltAddressList();
    } else if (
      this.isAltCustomerAddressChecked == false && this.isCustomerSelected) {
      this.newOrderForm.controls.soldToId.setValue(this.selectedSoldToCustomer.id);
      this.newOrderForm.controls.deliveryAddressId.setValue(0);
    }

    if (this.orderObj?.deliveryAddress && this.isAltCustomerAddressChecked) {
      this.newOrderForm.controls.deliveryAddressId.setValue(this.orderObj.deliveryAddress.id);
    }

    if (this.isAltCustomerAddressChecked == true) {
      this.newOrderForm.get('deliveryAddressId').enable();
      this.newOrderForm.get('deliveryAddressId').markAsUntouched();
      this.newOrderForm.get('deliveryAddressId').updateValueAndValidity();
    }

    if (this.isAltCustomerAddressChecked == false) {
      this.newOrderForm.get('deliveryAddressId').disable();
      this.newOrderForm.get('deliveryAddressId').markAsUntouched();
      this.newOrderForm.get('deliveryAddressId').updateValueAndValidity();
    }

  }

  directPayerChecked(event: any) {
  
    this.isDirectPayerSelected = event.checked;

    if (this.isDirectPayerSelected && this.selectedSoldToCustomer) {
      this.selectedPayerCustomer = this.selectedSoldToCustomer;

      this.newOrderForm.controls.isDirectPayer.setValue(true);
      this.newOrderForm.controls.payerId.setValue(this.newOrderForm.controls.soldToId.value);

      // Added to fix the Direct Payer Checkbox that will not allow the user to edit the payment terms
      if (!this.isPf) {
        this.newOrderForm.get('paymentTermsId').enable();
      }

      if (this.selectedPayerCustomer && this.selectedTerm !== this.selectedPayerCustomer.paymentTerms && !this.isPf && !this.pFChecked) {
        this.selectedTerm = this.selectedPayerCustomer.paymentTerms;
        this.newOrderForm.controls.paymentTermsId.setValue(this.selectedTerm.id);
        if (this.selectedTerm.id !== 8) {
          this.newOrderForm.controls.fixedPaymentDate.setValue(null);
          this.newOrderForm.get('fixedPaymentDate').disable();
          this.newOrderForm.controls.fixedPaymentDate.removeValidators(Validators.required);
          this.isPaymentDateVisable = false;
        }
      }

    } else if (!this.isDirectPayerSelected && this.selectedPayerCustomer) {
      this.newOrderForm.get('payerId').enable();
      this.newOrderForm.controls.payerId.setValue(0);
      this.newOrderForm.controls.coopOrderNumber.setValue('');
      this.selectedPayerCustomer = null;

      this.newOrderForm.controls.isDirectPayer.setValue(false);
    }

    if (this.selectedPayerCustomer) {
      if (this.getSGrp(this.selectedPayerCustomer).includes('ZAF')) {
        this.isPayerCoop = true;
      } else {
        this.isPayerCoop = false;
      }
    }

        //ENABLE/DISABLE  hideButtonOptions FOR DOWNLOAD / SUBMIT TO SAP / COPY ORDER 
    if(this.selectedPayerCustomer === null){
      this.hideButtonOptions = false;
   }else {
    this.hideButtonOptions = true;
   }
  }

  setSelectedAltAddress(selectedItem: AddressModel) {
    this.altAddress = selectedItem;
    this.selectedDeliveryAddressId = this.altAddress.id;
    this.isAltCustomerAddressSelected = true;
  }

  openOrderBackDialog() {
    if (this.orderObj?.id == undefined || this.orderObj?.orderStatus?.id == 1) {
      const dialogRef = this.orderBackDialog.open(OrderBackComponent, {

      });
      dialogRef.afterClosed().subscribe(() => {

      });
    } else {
      if (this.routingOrigins) {
        if (this.routingOrigins === 'approvals') {
          this.router.navigate(['/order-manager/approvals']);
        }
      } else {
        this.router.navigate(['/order-manager/my-orders']);
      }
    }
  }

  //APPROVE
  openApproveConfirmDialog() {
    const dialogRef = this.approveDialog.open(ApproveOrderComponent, {

    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.approveOrder();
      }
    });
  }

  //REJECT
  openRejectConfirmDialog() {
    const dialogRef = this.rejectDialog.open(RejectOrderComponent, {

    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.rejectOrder();
      }
    });
  }

  //ORDER DELETE DRAFT
  openRemoveOrderDialog() {
    const dialogRef = this.editAltAddressDialog.open(RemoveOrderComponent, {
      data: {
        orderId: this.orderObj.id,
      },
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  openEditAltAddressDialog() {
    const dialogRef = this.editAltAddressDialog.open(AddAltAddressComponent, {
      data: {
        tenantId: this.selectedSoldToCustomer.tenant.id,
      },
    }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.updateAltAddressDetails();
    });
  }

  openAddCoOpDialog() {

    const dialogRef = this.addCoOpDialog.open(AddCoOpComponent, {
      data: {
        soldToTenantId: this.selectedSoldToCustomer?.tenant?.id ?? this.orderObj.soldTo?.tenant?.id,
        payerTenantId: this.selectedPayerCustomer?.tenant?.id ?? this.orderObj.payer?.tenant?.id,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      setTimeout(() => {
        if (this.orderObj?.soldTo && this.orderObj?.payer) {
          this.populateCoOpMemberListDropDown(this.orderObj.soldTo?.tenant?.id, this.orderObj.payer?.tenant?.id);
        } else if (this.selectedSoldToCustomer && this.selectedPayerCustomer) {
          this.populateCoOpMemberListDropDown(this.selectedSoldToCustomer?.tenant?.id, this.selectedPayerCustomer?.tenant?.id);
        }

      }, 500)
    });
  }

  //ITEMS
  populateItemsLists() {
    if (this.orderObj?.id) {
      this.itemService.getItemList(this.orderObj.id)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.dataSource.data = response;
          this.items = response;

          if (this.items?.length == 0) {
            this.newOrderForm.get('soldToId').enable();
            this.newOrderForm.get('orderDate').enable();
            this.checkPayerValidation();
            this.isCopyOrderEnabled = false;
          } else {
            this.newOrderForm.get('soldToId').disable();
            this.newOrderForm.get('orderDate').disable();
            this.populateDiscountValidationList();
            this.populateOrderTotals();
            this.isCopyOrderEnabled = true;

            this.checkPayerValidation();
          }

      this.totalTons = this.items.reduce((accumulator, item) => {
        const unitId = item?.materialPricing?.unitOfMeasure?.id;
          if (unitId === 1) {
            return accumulator + item.qty;
          } else if (unitId === 2) {
            // Kg - convert to tons (divide by 1000)
            return accumulator + (item.qty / 1000);
          }
          // Skip other unit types
          return accumulator;
        }, 0);

      if (this.totalTons > 0) {
        this.convertedTotalTons = this.totalTons.toFixed(3);
      }
      
          for (let bool of response) {
            this.isOwnTransport = bool;
          }
        });
    }
  }

  populateOrderTotals() {
    this.ordersService.getOrderTotals(this.orderObj?.id)
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.orderTotals = response;
        this.newOrderForm.controls.totalPrice.setValue(response?.totalPrice);
      });
  }

  //ITEMS DISCOUNT VALIDATION
  populateDiscountValidationList() {
    this.itemService.getDiscountValidationList(this.orderObj?.id)
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.discountValidationItems = response;
      });
  }

  openClearItemsAlertDialog() {
    const dialogRef = this.clearItemsAlertDialog.open(ClearItemsComponent, {
      data: {
        items: this.items,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.populateItemsLists();
      this.populateDiscountValidationList();
      this.populateOrderTotals();
      this.nav.toggleLoading(false);
    });
  }

  openAddItemDialog() {
    this.nav.toggleLoading(true);
    let isNewItem: boolean = true;
    const dialogRef = this.addItemDialog.open(AddItemComponent, {
      data: {
        orderId: this.orderObj?.id,
        radius: this.newOrderForm.controls.radius.value ?? this.orderObj.radius,
        isItemEditMode: false,
        isNewItem: isNewItem,
        orderDate: this.newOrderForm?.controls?.orderDate?.value ?? this.orderObj?.orderDate,
        currentTotalTons: this.totalTons,
        selectedSoldToCustomer: this.selectedSoldToCustomer
      },
    });
    dialogRef.afterClosed().subscribe((result) => {

      this.nav.toggleLoading(true);
      setTimeout(() => {
        this.populateItemsLists();
        this.nav.toggleLoading(false);
      }, 1500)

    });
  }

  openDeleteItemDialog(items: ItemModel) {
    const dialogRef = this.deleteItemDialog.open(RemoveItemComponent, {
      data: {
        itemId: items.id,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => {
        this.populateItemsLists();
        this.populateDiscountValidationList();
        this.populateOrderTotals();
      }, 1000)
      this.nav.toggleLoading(false);
    });
  }

  openEditItemDialog(items: ItemModel) {
    const dialogRef = this.addItemDialog.open(AddItemComponent, {
      data: {
        itemId: items.id,
        isItemEditMode: true,
        radius: this.newOrderForm.controls.radius.value ?? this.orderObj.radius,
        orderDate: this.newOrderForm?.controls?.orderDate?.value ?? this.orderObj?.orderDate,
        orderId: this.orderObj.id,
        currentTotalTons: this.totalTons,
        selectedSoldToCustomer: this.selectedSoldToCustomer
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      setTimeout(() => {
        this.populateItemsLists();
      }, 500)
      this.nav.toggleLoading(false);
    });
  }

  // NOTES
  populateNotesLists() {
    if (this.orderObj?.id) {
      this.notesService
        .getNoteList(this.orderObj.id)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.notes = response;
        });
    }
  }
  openAddNoteDialog() {
    const dialogRef = this.addNoteDialog.open(AddNoteComponent, {
      data: {
        orderId: this.orderObj.id,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.populateNotesLists();
    });
  }

  openDeleteNoteAlertDialog(note: NotesModel) {
    const dialogRef = this.deleteNoteDialog.open(RemoveNoteComponent, {
      data: {
        noteID: note.id,
        orderId: note.orderId,
        note: note.note,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.populateNotesLists();
    });
  }
  openEditNoteAlertDialog(note: NotesModel) {
    const dialogRef = this.editNoteDialog.open(EditNoteComponent, {
      data: {
        noteID: note.id,
        orderId: note.orderId,
        note: note.note,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.populateNotesLists();
    });
  }

  // ATTACHMENTS
  populateAttachmentLists() {
    if (this.orderObj?.id) {
      this.attachmentsService
        .getAttachmentList(this.orderObj.id)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.attachments = response;
          this.nav.toggleLoading(false);
        });
    }
  }

  openAddNewAttachmentDialog() {
    const dialogRef = this.addNewAttachmentDialog.open(AttachItemComponent, {
      data: {
        orderId: this.orderObj.id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      setTimeout(() => {
        if (result === true) {
          this.populateAttachmentLists();
          this.nav.toggleLoading(false);
          this.snackBar.open('Adding New Attachment Successful', 'close', {
            duration: 5000,
          });
        }

      }, 1000);
    });
  }

  openRemoveAttachmentAlertDialog(attachment: AttachmentModel) {
    const dialogRef = this.removeAttachmentAlertDialog.open(
      RemoveAttachmentComponent,
      {
        data: {
          attachmentID: attachment.id,
          orderId: attachment.orderId,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.populateAttachmentLists();
    });
  }

  openEditAttachmentDialog(attachment: AttachmentModel) {
    const dialogRef = this.replaceAttachmentDialog.open(
      EditAttachmentComponent,
      {
        data: {
          attachmentID: attachment.id,
          orderId: attachment.orderId,
          fileName: attachment.documentName,
          description: attachment.description,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.populateAttachmentLists();
    });
  }

  downloadOrderReport() {
    if (this.newOrderForm.invalid) {
      this.orderValidation();

    } else if (this.newOrderForm.valid && this.items.length === 0) {
      this.snackBar.open("Please add at least one item to continue", "close", {
        duration: 5000,
      });
    } else if (this.newOrderForm.valid && this.items.length !== 0) {
      this.nav.toggleLoading(true);
      this.ordersService
        .getOrderReportById(this.orderObj.id).subscribe({
          next: (resp: HttpResponse<Blob>) => {

            let data = resp.body

            if (data) {
              const url = window.URL.createObjectURL(data);
              const link = document.createElement('a');
              link.href = url;

              link.setAttribute('download', String(resp.headers.get('content-disposition')));

              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
            }
            this.nav.toggleLoading(false);
          },
          error: (error) => {
            console.error(error);
            this.nav.toggleLoading(false);
            this.snackBar.open("Failed to download order report.", "close", {
              duration: 5000,
            });
          }
        });
    }
  }

  downloadSocReport() {
    if (this.newOrderForm.invalid) {
      this.orderValidation();
    } else if (this.newOrderForm.valid && this.items.length === 0) {
      this.snackBar.open("Please add at least one item to continue", "close", {
        duration: 5000,
      });
    } else if (this.orderObj?.orderStatus?.id === this.orderStatusTypeObj?.submittedToSapStatus ||
      this.orderObj?.orderStatus?.id === this.orderStatusTypeObj?.updatedSubmitedToSapStatus) {
      this.nav.toggleLoading(true);
      this.ordersService
        .getSocReportById(this.orderObj.id).subscribe({
          next: (resp: HttpResponse<Blob>) => {

            let data = resp.body


            if (data) {
              const url = window.URL.createObjectURL(data);
              const link = document.createElement('a');
              link.href = url;

              link.setAttribute('download', String(resp.headers.get('content-disposition')));

              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
            }
            this.nav.toggleLoading(false);
          },
          error: (error) => {
            console.error(error);
            this.nav.toggleLoading(false);
            this.snackBar.open("Failed to download SOC report.", "close", {
              duration: 5000,
            });
          }
        });

    }
  }

  //TODO:
  // mailtoPDF(){
  //   this.subject = 'Order: ' + String(this.orderObj.orderNumber) + ' : PDF - version';
  // }

  // mailtoSOC(){
  //   this.subject = 'Order: ' + String(this.orderObj.orderNumber) + ' : SOC - version';
  // }

  downloadAttachment(attachment: AttachmentModel) {
    this.nav.toggleLoading(true);
    this.attachmentsService
      .downloadAttachment(attachment.id)
      .pipe(
        catchError((error) => {
          console.error('An error occurred:', error);
          this.nav.toggleLoading(false);
          return of(null);
        })
      )
      .subscribe((response) => {
        if (response) {
          const file = new Blob([response], { type: 'application/*' });
          const url = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = attachment.documentName;
          link.click();
          window.URL.revokeObjectURL(url);
        }
        this.nav.toggleLoading(false);
      });
  }

  copyOrder() {

    if (this.items?.length === 0) {
      this.snackBar.open("Please add at least one item to continue", "close", {
        duration: 5000,
      });
    } else {
      const dialogRef = this.copyOrderComponentDialog.open(CopyOrderComponent,
        {
          data: {
            orderId: this.orderObj?.id,
            soldToObj: this.selectedSoldToCustomer ?? this.orderObj?.soldTo,
            payerObj: this.selectedPayerCustomer ?? this.orderObj?.payer
          }
        }
      );
      dialogRef.afterClosed().subscribe(result => {
        // this.nav.toggleLoading(false);
        if (result?.option === "createCopy") {
          this.router.navigate(['/order-manager/order', result?.responseOrderId]);
            this.refreshBrowser();
        }
        else if(result?.option === "cancelCopy"){
           //Close - cancel
        }
        // this.refreshBrowser();
      })
    }
  }

  updateFormOptionControls() {
    //ENABLE/DISABLE FORM INPUTS
    // if user id !== rep.user.id  hide approve/reject

    if (this.orderObj?.id == undefined) {
      this.isEditOrderOptionsEnabled = true;
    }

    if (this.orderObj?.id !== undefined && this.orderObj?.orderStatus?.id === this.orderStatusTypeObj?.draftStatus) {
      this.isEditOrderOptionsEnabled = true;
    }


    if (this.orderObj?.id) {
      if (this.orderObj?.orderStatus?.id >= this.orderStatusTypeObj?.submittedToSapStatus) {
        this.isEditOrderOptionsEnabled = false;

        this.disableOrderEditing();
      }

      let roleCheck = this.sessionStorage.getItem('roles');

      if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingManagerApprovalStatus && roleCheck.includes('OTCAgent')) {
        this.isPendingApproval = false;

      } else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingManagerApprovalStatus && roleCheck.includes('OTCRepresentative')) {
        this.isPendingApproval = false;

      } else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingManagerApprovalStatus && roleCheck.includes('OTCApprovingManager') && this.orderObj?.rep?.user?.id !== this.helper.getUserId()) {
        this.isPendingApproval = true;

      } else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingManagerApprovalStatus && roleCheck.includes('OTCOverallApprovingManager')) { //CAN APPROVE OWN ORDERS
        this.isPendingApproval = true;

      } else if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingTermManagerApprovalStatus && roleCheck.includes('OTCOverallApprovingManager')) { //CAN APPROVE OWN ORDERS
        this.isPendingApproval = true;

      } else if (this.orderObj?.rep?.user?.id === this.helper.getUserId()) {
        this.isPendingApproval = false;

      } else {
        this.isPendingApproval = false;
      }

      // Recall button logic
      if (this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingManagerApprovalStatus ||
          this.orderObj?.orderStatus?.id == this.orderStatusTypeObj?.pendingTermManagerApprovalStatus) {
        this.isRecallable = true;
        this.isRecallEnabled = this.orderObj?.creatingUser?.id == this.helper.getUserId()
            || this.orderObj?.creatingUser?.id == this.helper.getRepresentativeId();
      } else {
        this.isRecallable = false;
        this.isRecallEnabled = false;
      }

      //PF KB SET TERMS
      if (this.orderObj?.orderStatus?.id === this.orderStatusTypeObj?.draftStatus || this.orderObj?.orderStatus?.id === this.orderStatusTypeObj?.recalledStatus || this.orderObj?.id == undefined) {
        this.pFChecked = false;
        this.newOrderForm.get('paymentTermsId').enable();
        this.newOrderForm.get('fixedPaymentDate').disable();
      } else if (this.orderObj?.orderStatus?.id > this.orderStatusTypeObj?.draftStatus) {
        this.newOrderForm.get('paymentTermsId').disable();
      }

      //PAYER DEATAILS SET ENABLE/DISABLE
      if (this.orderObj?.orderStatus?.id === this.orderStatusTypeObj?.draftStatus || this.orderObj?.orderStatus?.id === this.orderStatusTypeObj?.recalledStatus || this.orderObj?.id == undefined) {
        // this.newOrderForm.get('payerId').enable();
        this.checkPayerValidation();
      } else if (this.orderObj?.orderStatus?.id >= this.orderStatusTypeObj?.submittedToSapStatus) {
        // this.newOrderForm.get('payerId').disable();
        this.checkPayerValidation();
      }

    }

  }

  approveOrder() {
    if (this.orderObj?.id) {
      this.ordersService.updateOrderApprovalStatus(this.orderObj.id, this.approveStatusId)
        .pipe(
          catchError((error) => {
            console.error(error);
            if (error?.status === 409) {
              this.snackBar.open('This order has been recalled and cannot be approved. Please refresh to see the latest status.', 'close', { duration: 8000 });
            }
            return throwError(() => error);
          })
        )
        .subscribe(() => {
          this.nav.toggleLoading(false);
          this.refreshBrowser();
        });
    }
  }

  rejectOrder() {
    if (this.orderObj?.id) {
      this.ordersService
        .updateOrderApprovalStatus(this.orderObj.id, this.rejectStatusId)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe(() => {
          this.refreshBrowser();
        });
    }
  }

  openRecallConfirmDialog() {
    const dialogRef = this.recallDialog.open(RecallConfirmationComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.recallOrder();
      }
    });
  }

  recallOrder() {
    if (this.orderObj?.id) {
      this.nav.toggleLoading(true);
      this.ordersService.recallOrder(this.orderObj.id).subscribe({
        next: () => {
          this.orderObj.orderStatus = { id: 13, description: 'Recalled', active: true };
          this.isRecallable = false;
          this.isRecallEnabled = false;
          this.isPendingApproval = false;
          this.isDraft = false;
          this.isEditOrderEnabled = true;
          this.isEditOrderOptionsEnabled = false;
          this.disableOrderEditing();
          this.nav.toggleLoading(false);
          this.snackBar.open('Order recalled successfully', 'close', { duration: 5000 });
        },
        error: (err) => {
          this.nav.toggleLoading(false);
          const status = err?.status;
          if (status === 403) {
            this.snackBar.open('You do not have permission to recall this order.', 'close', { duration: 5000 });
          } else if (status === 404) {
            this.snackBar.open('Order not found. Please refresh and try again.', 'close', { duration: 5000 });
          } else if (status === 409) {
            this.snackBar.open('This order cannot be recalled from its current status.', 'close', { duration: 5000 });
          } else {
            this.snackBar.open('An unexpected error occurred. Please try again.', 'close', { duration: 5000 });
          }
        }
      });
    }
  }

  refreshBrowser() {
    // FORCE REFRESH BROWSER
    setTimeout(() => {
      // this.ngOnInit();
      // window.location.reload();
      const orderId = String(this.orderObj.id);
      this.router.navigateByUrl('/order-manager/my-orders', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/order-manager/order/' + orderId]);
      });
    }, 1000)


  }

  checkPayerValidation() {
      //ONLY FOR DRAFT OR EDIT AFTER SAP SUBMISION  - ENABLE PAYER / DIRECT PAYER REGARDLESS IF ITEMS  HAVE BEEN ADDED TO ORDER 
      //DIRECT PAYER CHECKBOX SHOULD BE SET TO DISABLED IF PAYER MATCHES SOLD TO BUT PAYER DROP DOWN SHOULD REMAIN EDITABLE ON DRAFT OR EDIT/AFTER SAP SUBMISION
      if ((this.orderObj?.orderStatus.id === this.orderStatusTypeObj.draftStatus || 
          this.orderObj?.orderStatus.id === this.orderStatusTypeObj.recalledStatus ||
          this.orderObj?.orderStatus.id === this.orderStatusTypeObj.editSubmitedToSapStatus)) {
        if (this.selectedSoldToCustomer !== this.selectedPayerCustomer) {
          this.newOrderForm.get('payerId').enable();
          this.newOrderForm.get('isDirectPayer').enable();
        }
        if (this.isDirectPayerSelected == true) {
            this.newOrderForm.get('payerId').enable();
            this.newOrderForm.get('isDirectPayer').enable();
        }
      }
  }

  checkCoOpValidation() {

    let sGrp;

    this.customers.forEach(customer => {
      if (customer?.id == this.newOrderForm.controls.payerId.value) {
        sGrp = this.getSGrp(customer);
        if ((sGrp === 'ZAF' && this.newOrderForm.controls.coopOrderNumber.value == null) ||
          (sGrp === 'ZAF' && this.newOrderForm.controls.coopOrderNumber.value == '')
        ) {
          this.newOrderForm.controls.coopOrderNumber.setValidators(Validators.required);
          this.newOrderForm.get('coopOrderNumber').setErrors({ required: true });
          this.newOrderForm.get('coopOrderNumber').markAsTouched();
          this.newOrderForm.get('coopOrderNumber').updateValueAndValidity();
          this.isPayerCoop = true;
          this.snackBar.open("Please enter a Co-Op Order No. to continue", "close", {
            duration: 5000,
          });
        }
      } else if ((sGrp !== 'ZAF' && this.newOrderForm.controls.coopOrderNumber.value !== null) ||
        (sGrp !== 'ZAF' && this.newOrderForm.controls.coopOrderNumber.value !== '')
      ) {
        this.newOrderForm.get('coopOrderNumber').removeValidators(Validators.required);
        this.newOrderForm.get('coopOrderNumber').setErrors({ required: false });
        this.newOrderForm.get('coopOrderNumber').markAsUntouched();
        this.newOrderForm.get('coopOrderNumber').updateValueAndValidity();
      }
    })
  }

  checkFixedPaymentDateValidation() {
    if ((this.isPaymentDateVisable == false) && (this.newOrderForm.controls.paymentTermsId.value !== 8)) {
      setTimeout(() => {
        this.newOrderForm.controls.fixedPaymentDate.removeValidators(Validators.required);
        this.newOrderForm.get('fixedPaymentDate').updateValueAndValidity();
      }, 100)

    }

    if ((this.newOrderForm.controls.paymentTermsId.value == 8) && (this.newOrderForm.controls.fixedPaymentDate.value == null)) {
      this.newOrderForm.controls.fixedPaymentDate.setValidators(Validators.required);
      this.newOrderForm.get('fixedPaymentDate').setErrors({ required: true });
      this.newOrderForm.get('fixedPaymentDate').markAsTouched();
      this.newOrderForm.get('fixedPaymentDate').updateValueAndValidity();
    }
  }

  getSGrp(customer: any): string {
    return customer?.sGrp || customer?.sgrp || '';
  }

  protected readonly sessionStorage = sessionStorage;
}
